module.exports = __webpack_public_path__ + "img/9788958286301.f04cf01d.jpg";